import view from './view.js';

export {view};


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/knowledge/index.js